export default "__VITE_ASSET__RfgQOoe5__"